import { createSelector } from 'reselect';
import { filterResources } from 'util/resource-util';
import { Resource, UserFavorite, ResourcesState } from 'types';
import { ResourcesSections } from 'util/resources-util';

const clickAways = (state: ResourcesState) => {
  return state.entity.clickAways;
};
const favoriteResources = (state: ResourcesState) => state.entity.favoriteResources;
const getSelectedTags = (state: ResourcesState) => state.app.resource.selectedFilters.selectedTags;
const getSearchText = (state: ResourcesState) => state.app.resource.selectedFilters.searchText;

export const getFavoriteClickAways = createSelector(
  [clickAways, favoriteResources],
  (clickAways: Array<Resource>, favoriteResources: Array<UserFavorite>) =>
    clickAways
      .filter(clickAway =>
        favoriteResources.find(userFavorite => userFavorite.clickAwayId === clickAway.id)
      )
      .map(clickAway => {
        const favorites = favoriteResources.filter(
          userFavorite => userFavorite.clickAwayId === clickAway.id
        );
        clickAway.favorites = favorites.length ? favorites : [];

        return clickAway;
      })
);

export const getAllClickAwaysWithFavorites = createSelector(
  [clickAways, favoriteResources],
  (clickAways: Array<Resource>, favoriteResources: Array<UserFavorite>) => {
    return clickAways.map(clickAway => {
      const favorites = favoriteResources.filter(
        userFavorite => userFavorite.clickAwayId === clickAway.id
      );
      clickAway.favorites = favorites.length ? favorites : [];

      return clickAway;
    });
  }
);

export const getFilteredClickAways = createSelector(
  [
    getFavoriteClickAways,
    getAllClickAwaysWithFavorites,
    getSelectedTags,
    getSearchText,
    (_, resourcesSection) => resourcesSection
  ],
  (favoriteClickAways, allClickAwaysWithFavorites, selectedTags, searchText, resourcesSection) => {
    return filterResources(
      resourcesSection === ResourcesSections.MYSTUFF.code
        ? favoriteClickAways
        : allClickAwaysWithFavorites,
      selectedTags,
      searchText
    );
  }
);
